import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  // Store the attempted URL for redirecting after login
  localStorage.setItem('returnUrl', state.url);

  // Redirect to login page
  router.navigate(['/login']);
  return false;
};

export const superAdminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    localStorage.setItem('returnUrl', state.url);
    router.navigate(['/login']);
    return false;
  }

  if (authService.isSuperAdmin()) {
    return true;
  }

  // User is authenticated but not SuperAdmin
  router.navigate(['/unauthorized']);
  return false;
};
